import React from "react";
const AppData = React.createContext(null);
export default AppData;
